import { getMessages } from '../../../../../../store/constants';

export const START_FIRST_TRIAL_SNACKBAR_TEXT = getMessages().getText('free_version.upgrade.snackbar.text');
export const SNACKBAR_ID_START_FIRST_TRIAL = 'SNACKBAR_ID_START_FIRST_TRIAL';
